import Reflux, { RefluxAction } from "reflux";

const exported = {
    search: Reflux.createAction("search") as RefluxAction<[string, number]>
};

export default exported;

export const { search } = exported;
